import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Conso Group:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Balance Sheet Date:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Consolidated By:")
], -1)
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Consolidated Date:")
], -1)
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "row mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Status:")
], -1)
const _hoisted_24 = {
  class: "col-md-6",
  style: {"padding":"0.5rem 1rem"}
}
const _hoisted_25 = {
  key: 2,
  class: "row mb-3"
}
const _hoisted_26 = {
  key: 3,
  class: "row mb-3"
}
const _hoisted_27 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_29 = {
  key: 4,
  class: "row mb-3"
}
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_33 = { class: "row mb-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_35 = { class: "d-flex col-md-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " Do you want to create a new journal from previous journal? ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, " Do you want to create a new carry forward journal? ", -1)
const _hoisted_41 = { class: "row mb-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Conso Group:")
], -1)
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "row mb-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Balance Sheet Date:")
], -1)
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onDeleteEvent: _ctx.deleteJournal,
                    onImportEvent: _ctx.importFile,
                    onExportEvent: _ctx.exportFile,
                    renderDelete: (!_ctx.isViewer && _ctx.identifier != null ? true : false),
                    renderImport: (!_ctx.isViewer && _ctx.journal.status == 'Created' ? true : false),
                    renderExport: (!_ctx.isViewer && _ctx.journal.status != '' ? true : false),
                    isDeleting: _ctx.isDeleting,
                    isImporting: _ctx.isImporting,
                    isExporting: _ctx.isExporting
                  }, null, 8, ["onDeleteEvent", "onImportEvent", "onExportEvent", "renderDelete", "renderImport", "renderExport", "isDeleting", "isImporting", "isExporting"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.consoGroups,
                                optionLabel: "name",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['name'],
                                showClear: "",
                                placeholder: _ctx.isConsoGroupLoading ? ('Loading...') : '-- Please Select --',
                                loading: _ctx.isConsoGroupLoading,
                                modelValue: _ctx.journal.consoGroup.identifier,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.journal.consoGroup.identifier) = $event)),
                                disabled: _ctx.identifier != null
                              }, null, 8, ["options", "placeholder", "loading", "modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_Calendar, {
                                dateFormat: "yy-mm-dd",
                                manualInput: true,
                                placeholder: "Balance Sheet Date",
                                modelValue: _ctx.journal.balanceSheetDate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.journal.balanceSheetDate) = $event)),
                                disabled: _ctx.identifier != null
                              }, null, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_Divider, { type: "solid" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _hoisted_18,
                                  _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.journal.submissionBy,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.journal.submissionBy) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _hoisted_20,
                                  _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_InputText, {
                                      class: "p-inputtext",
                                      type: "text",
                                      maxlength: "50",
                                      modelValue: _ctx.journal.submissionDate,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.journal.submissionDate) = $event)),
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _hoisted_23,
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_Badge, {
                                      class: _normalizeClass(["mr-2", [_ctx.journal.status == 'Consolidated' ? 'p-badge-success' : 'p-badge-warning']]),
                                      value: _ctx.journal.status
                                    }, null, 8, ["class", "value"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createVNode(_component_Divider)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_Button, {
                                    class: "p-button-sm",
                                    onClick: _ctx.addJournalEntity,
                                    label: "Add Journal Entity",
                                    disabled: _ctx.journal.status == 'Consolidated',
                                    hidden: _ctx.isViewer
                                  }, null, 8, ["onClick", "disabled", "hidden"]),
                                  _hoisted_28,
                                  _createVNode(_component_Button, {
                                    class: "p-button-sm",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCarryForwardDialog())),
                                    label: "Create Carry Forward Journal",
                                    hidden: _ctx.isViewer
                                  }, null, 8, ["hidden"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_DataTable, {
                                    value: _ctx.journal.journalEntities,
                                    responsiveLayout: "scroll",
                                    selectionMode: "row",
                                    sortField: "id",
                                    sortOrder: 1,
                                    paginator: "",
                                    rows: 10,
                                    paginatorPosition: "top",
                                    onRowClick: _ctx.viewJournalEntity
                                  }, {
                                    empty: _withCtx(() => [
                                      (_ctx.journal.journalEntities.length <= 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createVNode(_component_FontAwesomeIcon, {
                                              icon: ['fas', 'image'],
                                              size: "2x"
                                            }),
                                            _hoisted_32
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_Column, {
                                        style: {"width":"15%"},
                                        field: "id",
                                        header: "ID",
                                        sortable: true
                                      }),
                                      _createVNode(_component_Column, {
                                        style: {"width":"15%"},
                                        field: "companyCode",
                                        header: "Entity",
                                        sortable: ""
                                      }),
                                      _createVNode(_component_Column, {
                                        style: {"width":"60%"},
                                        field: "description",
                                        header: "Description",
                                        sortable: ""
                                      }),
                                      _createVNode(_component_Column, {
                                        style: {"width":"10%"},
                                        header: ""
                                      }, {
                                        body: _withCtx((slotProps) => [
                                          _createVNode(_component_Button, {
                                            icon: "pi pi-trash",
                                            severity: "danger",
                                            text: "",
                                            rounded: "",
                                            onClick: ($event: any) => (_ctx.removeJournalEntity(slotProps.data)),
                                            title: "Delete",
                                            disabled: _ctx.journal.status == 'Consolidated',
                                            hidden: _ctx.isViewer
                                          }, null, 8, ["onClick", "disabled", "hidden"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value", "onRowClick"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createElementVNode("div", _hoisted_35, [
                              (_ctx.identifier == null)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    class: "p-button-sm",
                                    disabled: _ctx.v$.journal.$invalid || _ctx.isLoading,
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSaveConfirmationDialog())),
                                    label: "Save"
                                  }, null, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                              _hoisted_36,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.cancel,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              _hoisted_37,
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 1 }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowConfirmation,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isShowConfirmation) = $event)),
      header: "Create from Previous Journal",
      modal: "",
      style: { width: '50vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save(false))),
          text: ""
        }),
        _hoisted_39,
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.save(true))),
          disabled: _ctx.v$.selectedJournal.$invalid || _ctx.isLoading
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _hoisted_38,
        _createVNode(_component_DataTable, {
          class: "p-datatable p-component align-middle mb-0 w-12",
          value: _ctx.previousJournals,
          selection: _ctx.selectedJournal,
          "onUpdate:selection": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedJournal) = $event)),
          paginator: "",
          rows: 5
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              style: {"width":"10%"},
              selectionMode: "single"
            }),
            _createVNode(_component_Column, {
              style: {"width":"65%"},
              field: "fileId",
              header: "File ID"
            }),
            _createVNode(_component_Column, {
              style: {"width":"25%"},
              field: "balanceSheetDate",
              header: "Balance Sheet Date"
            })
          ]),
          _: 1
        }, 8, ["value", "selection"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowCarryForward,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isShowCarryForward) = $event)),
      header: "Create Carry Forward Journal",
      modal: "",
      style: { width: '50vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveCarryForwardJournal(false))),
          text: ""
        }),
        _hoisted_47,
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveCarryForwardJournal(true))),
          disabled: _ctx.v$.carryForwardJournal.$invalid || _ctx.isLoading
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_Dropdown, {
              options: _ctx.consoGroups,
              optionLabel: "name",
              optionValue: "identifier",
              filter: "",
              filterFields: ['name'],
              showClear: "",
              placeholder: _ctx.isConsoGroupLoading ? ('Loading...') : '-- Please Select --',
              loading: _ctx.isConsoGroupLoading,
              modelValue: _ctx.carryForwardJournal.consoGroup.identifier,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.carryForwardJournal.consoGroup.identifier) = $event))
            }, null, 8, ["options", "placeholder", "loading", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_Calendar, {
              dateFormat: "yy-mm-dd",
              manualInput: true,
              placeholder: "Balance Sheet Date",
              modelValue: _ctx.carryForwardJournal.balanceSheetDate,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.carryForwardJournal.balanceSheetDate) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}